const kind = kind => {
  if (kind === 'C') {
    return 'Pessoa jurídica'
  }

  return 'Pessoa física'
}

export default kind
